import React from 'react';
import { GCMain, GCTitle, GCSubTitle, GCDescription } from './GraphContainer.style';

import GraphMaster from '../GraphMaster/GraphMaster';
import GraphMasterDouble from '../GraphMasterDouble/GraphMasterDouble';
import SimpleModal from '../Modal';

const GraphContainer = (props) => {

  let { data, type, title, subtitle, description } = props;

  let getData = (info) => {
    if(info) {
      let arreglo = info.data ? info.data : info;
      let register = arreglo ? type === "Precios_Stats_Conteo" ? arreglo.find( element => element.name === "Precios_Stats") : arreglo.find( element => element.name === type) : []
         return type === "TrendGeneral_Bars" ? 
          (() => {
            return  <GraphMasterDouble data={register} />
          })() 
          : type === "TrendGeneral" ? 
          (() => {
            return  <GraphMaster data={register}/>
          })() 
          : type === "Trend_Region_Map" ? 
          (() => {
            return  <GraphMasterDouble data={register} />
          })() 
          : type === "Trend_Region" ? 
          (() => {
            return  <GraphMaster data={register}/>
          })()
          : type === "TrendSemaforo1" ? 
          (() => {
            return  <GraphMasterDouble data={register} />
          })() 
          : type === "TrendSemaforo2" ? 
          (() => {
            return  <GraphMasterDouble data={register} />
          })()
          : type === "TrendSemaforo4" ? 
          (() => {
            return  <GraphMasterDouble data={register} />
          })()
          : type === "Trend_Region_Map" ? 
          (() => {
            return  <GraphMasterDouble data={register} />
          })() 
          : type === "Trend_Region" ? 
          (() => {
            return  <GraphMaster data={register}/>
          })()
          :
          type === "Precios_Stats_Conteo" ?
          (() => {
            let newRegister =  register ? register : {}
            newRegister['name']= "Precios_Stats_Conteo"
            return  <GraphMaster data={newRegister} special="Precios_Stats_Conteo"/>
          })() 
          : type === "MapaCompetencia" ? 
          (() => {
            let newRegister =  register ? register : {}
            newRegister['name']= "MapaCompetencia"
            return  <GraphMasterDouble data={newRegister} special="MapaCompetencia"/>
          })()
          : 
          (() => <GraphMaster data={register}/>)()
      // }
    } else console.log('no hay info');
  }

  return (
    
    <GCMain style={{width: props.wi, height: props.he}}>
      <SimpleModal data={{...data, type, title, subtitle, description}} />
      <GCTitle>{ title }</GCTitle>
      <GCSubTitle>{ subtitle }</GCSubTitle>
      {
        getData(data)
      }
      {/* <GCDescription>{ graphDescription }</GCDescription> */}
    </GCMain>
  );
}

export default GraphContainer;
